/**
 * @generated SignedSource<<6f05f7b1819ddb8f35275fc9b8c40e09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartmentAvailabilityCoursePicker_facilityToCourseOption$data = {
  readonly courses: {
    readonly count: number;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentType": "DepartmentAvailabilityCoursePicker_facilityToCourseOption";
};
export type DepartmentAvailabilityCoursePicker_facilityToCourseOption$key = {
  readonly " $data"?: DepartmentAvailabilityCoursePicker_facilityToCourseOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartmentAvailabilityCoursePicker_facilityToCourseOption">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "DepartmentAvailabilityCoursePicker_facilityToCourseOption"
};

(node as any).hash = "d09c0f706dcef25843e3eae3d3727716";

export default node;
